export const TOKEN_KEY = 'sc-token';
export const ID_KEY = 'sc-uid';
export const WHITE_TIP = '系统暂不支持该媒体类型，请联系平台管理员！';
